import {
  Box,
  FormControl,
  Stack,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SelectDateRange from 'src/components/SelectDateRange';
import { useAppSelector } from 'src/app/hooks';
import ModalSelectWidget from 'src/components/ModalSelectWidget';
import DateRangeLabel from '../../components/DateRangeLabel';

const CustomBox = styled(Box)(
  ({ theme }) => `
    //width: calc(100vw - ${theme.sidebar.width} - ${theme.spacing(10)});
    margin: ${theme.spacing(2, 0)};
    // position: absolute;
`
);

const FilterBox = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`
);

function BottomHeader() {
  const theme = useTheme();
  const { dashboardSelectedById } = useAppSelector(
    (state) => state.storeCustomDashboard
  );

  const matchedMediaUpMd = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <CustomBox>
      <FilterBox>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
          <FormControl size="small" sx={{ width: { md: 135 } }}>
            <SelectDateRange />
          </FormControl>
          {matchedMediaUpMd && (
            <ModalSelectWidget
              prevSelectedWidget={
                dashboardSelectedById?.customDashboardWidgetMetadataList ?? []
              }
            />
          )}
        </Stack>
      </FilterBox>
      <DateRangeLabel label={`Viewing data within`} />
    </CustomBox>
  );
}

export default BottomHeader;
